import isEqual from 'fast-deep-equal/react';

export const filterBySubject = (data) => {
  const uniqueItems = [];

  data.forEach((day) => {
    day.data.forEach((item) => {
      const filteredItem = {
        CARRERA: item.CARRERA,
        ASIGNATURA: item.ASIGNATURA,
        SECCION: item["SECCIÓN"],
        TIPO_DE_CLASE: item["TIPO DE CLASE"],
      };

      const allFieldsAreEmpty = Object.values(filteredItem).every((field) => field === undefined || (typeof field === 'string' && field.trim().length === 0));

      if (!allFieldsAreEmpty) {
        const isDuplicate = uniqueItems.some((element) => isEqual(element, filteredItem));
        if (!isDuplicate) {
          uniqueItems.push(filteredItem);
        }
      }
    });
  });

  return uniqueItems;
};

export class classGroupDay {
  constructor(dataSheetDay = []) {
    this.data = dataSheetDay.data;
    this.id = dataSheetDay.id
  }

  getDayTitle() {
    return this.id;
  }

  getMainInformation() {
    return this.data.map(item =>
      `[${item.CARRERA}/${item.SEMESTRE}º/Sec: ${item.SECCIÓN}/Tipo: ${item["TIPO DE CLASE"]}] ${item.ASIGNATURA}`);
  }

  getAllClassData() {
    const transformData = this.data.map(item => {
      const objectData = Object.assign({"Clase":`[${item.CARRERA}/${item.SEMESTRE}º/Sec: ${item.SECCIÓN}/Tipo: ${item["TIPO DE CLASE"]}] ${item.ASIGNATURA}`}
      , item)
      return objectData
    })
    return transformData
  }
}
  /*
/ Example data
const exampleData = {
"id": "Lunes 17/07/2023",
"data": [
{ "N": "1", "SEMESTRE": "2", "CARRERA": "CB", "ASIGNATURA": "COMPUTACION", "SECCIÓN": "A", "TIPO DE CLASE": "T", "DOCENTE": "ING.DAVID FRETES", "OBSERVACIÓN": "", "REEMPLAZANTE": "", "HORA INICIO": "7:30", "": "9:20", "AULA": "R1" },
{ "N": "2", "SEMESTRE": "2", "CARRERA": "CB", "ASIGNATURA": "FISICA 2", "SECCIÓN": "E", "TIPO DE CLASE": "T", "DOCENTE": "ING.RICARDO GIMENEZ", "OBSERVACIÓN": "", "REEMPLAZANTE": "", "HORA INICIO": "7:30", "": "11:20", "AULA": "F1" },
{ "N": "3", "SEMESTRE": "4", "CARRERA": "CB", "ASIGNATURA": "MECANICA DE MATERIALES 1", "SECCIÓN": "D", "TIPO DE CLASE": "T", "DOCENTE": "MARTIN BALMACEDA", "OBSERVACIÓN": "", "REEMPLAZANTE": "", "HORA INICIO": "7:30", "": "10:20", "AULA": "R5" },
{ "N": "4", "SEMESTRE": "5", "CARRERA": " ", "ASIGNATURA": " ", "SECCIÓN": "", "TIPO DE CLASE": " ", "DOCENTE": "", "OBSERVACIÓN": "", "REEMPLAZANTE": "", "HORA INICIO": " ", "": " ", "AULA": " " },
{ "N": "5", "SEMESTRE": "2", "CARRERA": "CB", "ASIGNATURA": "QUIMICA GENERAL", "SECCIÓN": "B", "TIPO DE CLASE": "T", "DOCENTE": "NESTOR BARRETO", "OBSERVACIÓN": "", "REEMPLAZANTE": "", "HORA INICIO": "8:00", "": "9:50", "AULA": "F4" }
]
};
 
const groupDay = new classGroupDay(exampleData);
 
console.log("Day Title:", groupDay.getDayTitle());
console.log("Main Information:", groupDay.getMainInformation());
console.log("Class by Index (4):");
console.log(groupDay.getClassByIndex(4));
*/